import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getVmsDefaultLandingPath, hasAnyVmsRole } from '../utils/vmsRole';
import { PageLoader } from './LoadingStates';

/** Annexure / form-hub definition management: Department RM, BH, stakeholder, or admin. */
const VmsAnnexureManagementRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <PageLoader message="Loading..." />;
  }
  if (!hasAnyVmsRole(user, ['business_owner', 'admin', 'business_head', 'stakeholder'])) {
    return <Navigate to={getVmsDefaultLandingPath(user)} replace />;
  }
  return <>{children}</>;
};

export default VmsAnnexureManagementRoute;
